module.exports = __webpack_public_path__ + "static/media/defaultImage.b1857ccd.webp";